import { createAction, props } from '@ngrx/store';
import { AuthData } from '../../../../models';

export enum SeSideReportHistoryComponentActions {
    SET_PATIENT = '[SeSideReportHistoryComponentActions] SetPatient',
    SET_SCOURCES = '[SeSideReportHistoryComponentActions] SetSources',
    NO_RESULT = '[SeSideReportHistoryComponentActions] NoResult',
    SET_SELECTED_ITEM = '[SeSideReportHistoryComponentActions] SetSelectedItem',
}

// @TODO gli items: any sono eprEvents??

export const seSideReportHistoryComponentSetPatient =
    createAction(SeSideReportHistoryComponentActions.SET_PATIENT, props<{ formType: any; patientId: string; isAllBuSearch?: boolean; credentials?: AuthData; }>());

export const seSideReportHistoryComponentNoResult =
    createAction(SeSideReportHistoryComponentActions.NO_RESULT, props<{ formType: any; message: string; }>());

export const seSideReportHistoryComponentSetSelectedItem =
    createAction(SeSideReportHistoryComponentActions.SET_SELECTED_ITEM, props<{ formType: any; item: any; }>());

export const seSideReportHistoryComponentSetSources =
    createAction(SeSideReportHistoryComponentActions.SET_SCOURCES, props<{ sources: string[]; }>());
